import React, { Component, Fragment } from 'react'
import api from '../../../utils/api'
import { Typeahead } from 'react-bootstrap-typeahead'
import warningLogo from '../../../utils/images/warningLogo.png'

export default class PollingStation extends Component {
  constructor(props) {
    super(props)

    if (this.props.data !== undefined) {
      this.state = {
        name: this?.props?.data?.data?.meta?.name || '',
        district: this?.props?.data?.data?.meta?.district || '',
        vidhanSabha: this?.props?.data?.data?.meta?.vidhanSabha || '',
        updateConstData: true,
      }
    } else {
      this.state = {
        name: '',
        updateConstData: false,
        district: '',
        vidhanSabha: '',
      }
    }
  }

  district = []
  vidhanSabha = []

  showWarning = false

  showConfirmBox = false

  componentDidMount() {
    //Fetch district

    api
      .getConstituencyData({
        type: 'Zila Level',
        limit: '1000',
        offset: '0',
      })
      .then((response) => {
        if (response.ok) {
          if (response.data.data === undefined) {
            this.showWarning = true
          } else {
            response.data.data.rows.map((wonderer) =>
              this.district.includes(wonderer.meta.name)
                ? null
                : this.district.push(wonderer.meta.name)
            )
          }
        }
      })
  }

  fetchVidhanSabha = (district) => {
    this.vidhanSabha = []
    api
      .getConstituencyData({
        type: 'Vidhan Sabha',
        limit: '10000',
        offset: '0',
      })
      .then((response) => {
        if (response.ok) {
          if (response.data.data === undefined) {
            this.showWarning = true
          } else {
            response.data.data.rows.forEach((wonderer) =>
              wonderer.meta.district === district
                ? this.vidhanSabha.includes(wonderer.meta.name)
                  ? null
                  : this.vidhanSabha.push(wonderer.meta.name)
                : null
            )
          }
          this.showVidhanSabha = true
        }
      })
  }

  render() {
    return (
      <Fragment>
        {this.showWarning ? (
          <div className="warningMsg">
            <div className="warningHead">
              <img className="warningLogo" src={warningLogo} alt=""></img>
              <p>Warning</p>
            </div>
            <p className="warningTxt">
              Please Make atleast one District & Vidhan Sabha
            </p>
          </div>
        ) : (
          <Fragment>
            <form
              onSubmit={(e) => {
                let body = {
                  ...this.state,
                }

                delete body.updateConstData

                this.props.getConstituencyData(e, body)
                this.setState({
                  name: '',
                  updateConstData: false,
                })
              }}
            >
              <div className="TxtInputFrame">
                <p className="TxtInput">Polling Station</p>
                <p className="TxtStar">*</p>
              </div>
              <input
                type="text"
                className="InputFrame"
                placeholder="Please enter Polling Station"
                onChange={(e) => this.setState({ name: e.target.value })}
                value={this.state.name}
                required
              />

              <Fragment>
                <div className="TxtInputFrame">
                  <p className="TxtInput">District</p>
                  <p className="TxtStar">*</p>
                </div>
                <Typeahead
                  id="district"
                  labelKey="district"
                  placeholder="Please select a District"
                  onChange={(district) => {
                    this.setState({ district: district[0] })
                    this.fetchVidhanSabha(district[0])
                  }}
                  options={this.district}
                  defaultInputValue={this.state.district}
                />
              </Fragment>

              {this.state?.district && this.state?.district !== '' ? (
                <Fragment>
                  <div className="TxtInputFrame" style={{ marginTop: '30px' }}>
                    <p className="TxtInput">Vidhan Sabha</p>
                    <p className="TxtStar">*</p>
                  </div>
                  <Typeahead
                    id="vidhanSabha"
                    labelKey="vidhanSabha"
                    placeholder="Please select a Vidhan Sabha"
                    onChange={(vidhanSabha) => {
                      this.setState({ vidhanSabha: vidhanSabha[0] })
                    }}
                    options={this.vidhanSabha}
                    defaultInputValue={this.state.vidhanSabha}
                  />
                </Fragment>
              ) : null}

              {this.state.updateConstData ? (
                <input
                  type="submit"
                  value="Update"
                  className="BtnSubmit"
                  onClick={() => {
                    this.showConfirmBox = true
                  }}
                />
              ) : (
                <input
                  type="submit"
                  value="Submit"
                  className="BtnSubmit"
                  onClick={() => {
                    this.showConfirmBox = true
                  }}
                />
              )}
            </form>
          </Fragment>
        )}
      </Fragment>
    )
  }
}
